export const messages = {
  en: {
    address: {
      addNewAddress: 'Add New Address',
      delete: 'Delete',
      deleteSuccess: 'Delete Success',
      addAddress: 'Add Address',
      receiver: 'Receiver',
      phone: 'Phone',
      region: 'Region',
      detailAddress: 'Detail Address',
      postalCode: 'Postal Code',
      setDefault: 'Set as Default Address',
      selectProvince: 'Select Province',
      selectCity: 'Select City',
      selectDistrict: 'Select District',
      receiverRequired: 'Receiver name is required',
      receiverMaxLength: 'Receiver name cannot exceed 30 characters',
      phoneRequired: 'Phone number is required',
      phoneFormat: 'Invalid phone number format',
      detailAddressRequired: 'Detail address is required',
      detailAddressMaxLength: 'Detail address cannot exceed 50 characters',
      saveSuccess: 'Save Success'
    },
    common: {
      cancel: 'Cancel',
      save: 'Save'
    }
  },
  zh: {
    address: {
      addNewAddress: '添加新地址',
      delete: '删除',
      deleteSuccess: '删除成功',
      addAddress: '新增收货信息',
      receiver: '收货人',
      phone: '手机号码',
      region: '所在地区',
      detailAddress: '详细地址',
      postalCode: '邮政编码',
      setDefault: '设为默认地址',
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectDistrict: '请选择区县',
      receiverRequired: '收货人名称不能为空',
      receiverMaxLength: '收货人名称不能超过30个字符',
      phoneRequired: '手机号码不能为空',
      phoneFormat: '手机号格式错误',
      detailAddressRequired: '详细地址不能为空',
      detailAddressMaxLength: '详细地址不能超过50个字符',
      saveSuccess: '保存成功'
    },
    common: {
      cancel: '取消',
      save: '保存'
    }
  }
}